export default {
    plans (state) {
      return state.plans
    },

    selectedPlan (state) {
        return state.selectedPlan
    },

    getPlan: state => (id) => {
      return state.plans.find(plan => plan.packageId == id)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/plans/getters.js